import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

export interface AgentOffering {
  agent: string;
  sessionUUID: string;
  [key: string]: any; // If additional data comes, this avoids TS errors
}

interface AgentsOfferingState {
  items: AgentOffering[];
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: AgentsOfferingState = {
  items: [],
  status: "idle",
  error: null,
};

export const createAgentsOffering = createAsyncThunk<AgentOffering, AgentOffering>(
  "agentsOffering/create",
  async (data) => data
);

export const removeAgentsOfferingBySessionId = createAsyncThunk<string, string>(
  "agentsOffering/removeBySessionId",
  async (sessionUUID) => sessionUUID
);

export const removeAgentsByAgentsId = createAsyncThunk<string, string>(
  "agentsOffering/removeByAgentId",
  async (agentId) => agentId
);

const agentsOfferingSlice = createSlice({
  name: "agentsOffering",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createAgentsOffering.fulfilled, (state, action: PayloadAction<AgentOffering>) => {
        const index = state.items.findIndex(
          (item) => item.agent === action.payload.agent
        );
        if (index === -1) {
          state.items.push(action.payload);
        } else {
          state.items[index] = action.payload;
        }
      })
      .addCase(removeAgentsOfferingBySessionId.fulfilled, (state, action) => {
        state.items = state.items.filter(item => item.sessionUUID !== action.payload);
      })
      .addCase(removeAgentsByAgentsId.fulfilled, (state, action) => {
        state.items = state.items.filter(item => item.agent !== action.payload);
      });
  },
});

export default agentsOfferingSlice.reducer;
